import {element} from './dom';
import {withIcon, type WorkspaceIcon} from './workspace-icons';

/** Native disclosure with keyboard and outside-click dismissal. No focus trap. */
export function actionMenu(label: string, actions: HTMLElement[], icon?: WorkspaceIcon): HTMLDetailsElement {
  const menu = element('details', 'action-menu');
  const trigger = element('summary', 'button button-quiet', label);
  if (icon) withIcon(trigger, icon);
  const items = element('div', 'action-menu-items');
  items.append(...actions);
  menu.append(trigger, items);
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) {
      event.preventDefault(); menu.open = false; trigger.focus();
    } else if (event.key === 'ArrowDown' && event.target === trigger) {
      event.preventDefault(); menu.open = true;
      items.querySelector<HTMLElement>('button:not(:disabled), a')?.focus();
    }
  });
  document.addEventListener('pointerdown', event => {
    if (menu.open && event.target instanceof Node && !menu.contains(event.target)) menu.open = false;
  });
  return menu;
}
